import React from 'react'

import { SUMMARY_ROW_ID } from '@fourthwall/module-analytics'

import { TimezonedDateString } from '../../../../../../../../Timezone/components/TimezonedDateString'
import type { AnalyticsParams } from '../../../../../modules/AnalyticsParams'
import type { AnalyticsReportStatsTable } from '../AnalyticsReport.types'
import { getDateFormat } from './getDateFormat'

export const createChartStatsTableColumnsMembersChange = (
  params: AnalyticsParams,
): AnalyticsReportStatsTable<any>['columns'] => [
  {
    header: params.precision === 'HOUR' ? 'Time' : 'Day',
    render: (item) => {
      if (item.id === SUMMARY_ROW_ID) return item.day

      return (
        <TimezonedDateString
          date={item.day}
          format={getDateFormat(params.precision)}
          withTimezoneAbbreviation={false}
        />
      )
    },
  },
  {
    header: 'Change',
    render: (item) => <span>{(item.change <= 0 ? '' : '+') + item.change}</span>,
  },
]
